import { NavIdsEnum } from '@components/header-landing/constants';
import { OffersModel } from '@remote-data/load-offers/types';
import PlanCard from '@screens/lp-default/components/plans/card';
import { PlanCardContents } from '@screens/lp-default/components/plans/constants';
import * as Styles from '@screens/lp-default/components/plans/styles';

type PlansProp = {
  id: NavIdsEnum;
  offers: OffersModel;
  isLoading: boolean;
};

export default function Plans({ id, offers, isLoading }: PlansProp) {
  return (
    <Styles.PlansContainer id={id} data-testid={id}>
      <Styles.PlansTitle>Planos disponíveis</Styles.PlansTitle>
      <Styles.PlansSubtitle>Encontre o plano ideal para o que você precisa</Styles.PlansSubtitle>
      <Styles.PlanCardContainer>
        {PlanCardContents.map((plan) => (
          <PlanCard {...plan} offers={offers} showOffers={!isLoading && plan.showOffers} key={plan.title} />
        ))}
      </Styles.PlanCardContainer>
    </Styles.PlansContainer>
  );
}
